function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.9999 19.6C15.3018 19.6 19.5999 15.302 19.5999 10C19.5999 4.69809 15.3018 0.400024 9.9999 0.400024C4.69797 0.400024 0.399902 4.69809 0.399902 10C0.399902 15.302 4.69797 19.6 9.9999 19.6ZM7.5999 6.40002C7.5999 5.07454 8.67442 4.00002 9.9999 4.00002C11.3254 4.00002 12.3999 5.07454 12.3999 6.40002C12.3999 7.72551 11.3254 8.80002 9.9999 8.80002C8.67442 8.80002 7.5999 7.72551 7.5999 6.40002ZM6.99988 10L12.9999 10C13.994 10 14.7999 10.8059 14.7999 11.8C14.7999 13.1393 14.2491 14.2123 13.3453 14.9378C12.4558 15.6518 11.2636 16 9.9999 16C8.73621 16 7.544 15.6518 6.65448 14.9378C5.75067 14.2123 5.1999 13.1393 5.1999 11.8C5.1999 10.806 6.00578 10 6.99988 10Z",
  fill: "black",
  fillOpacity: 0.6
});

function SvgPerson2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson2);
export default __webpack_public_path__ + "static/media/person-2.35470931.svg";
export { ForwardRef as ReactComponent };